import { APIResponseBFFData } from "@superagents/types/api/api.v5";
import { createContext } from "react";

interface AuthContextType {
  register: (
    email: string,
    password: string
  ) => Promise<APIResponseBFFData<"bff::user"> & { id: number }>;
  forgotPassword: (email: string) => Promise<{ ok: boolean }>;
  resetPassword: (
    code: string,
    password: string,
    passwordConfirmation: string
  ) => Promise<{ ok: boolean }>;
  login: (
    identifier: string,
    password: string
  ) => Promise<APIResponseBFFData<"bff::user">>;
  loginWithGoogle: (
    accessToken: string
  ) => Promise<APIResponseBFFData<"bff::user">>;
  logout: () => void;
  user?: APIResponseBFFData<"bff::user">;
  token?: string;
  isLoggingIn: boolean;
  isUserLoading: boolean;
  isLoggedIn: boolean;
}

export const AuthContext = createContext<AuthContextType | null>(null);
